<template>
    <van-dialog :value="visible" :title="title" show-cancel-button confirm-button-color="#28b86a" @confirm="confirmDialog" @cancel="cancelDialog" :confirmButtonText="$t('table.confirm')" :cancelButtonText="$t('table.cancel')">
        <van-picker ref="vanpicker" :default-index="defaultindex" :columns="columns" :visible-item-count="count" @confirm="confirm" />
    </van-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        columns: {
            type: Array,
            default: () => {
                return [];
            },
        },
        defaultcode: {
            type: String,
            default: "",
        },
        count: {
            type: Number,
            default: 4,
        },
    },
    computed: {
        defaultindex() {
            let index = 0;
            if (this.defaultcode) {
                index = this.columns.findIndex(
                    (item) => item.code == this.defaultcode
                );
            }
            return index;
        },
    },
    data() {
        return {
            active: {},
        };
    },
    methods: {
        confirmDialog() {
            this.$refs.vanpicker.confirm();
            this.$emit("update:visible", false);
            console.log("选中项:", this.active);
            this.$emit("active", this.active);
        },
        cancelDialog() {
            this.$emit("update:visible", false);
        },
        confirm(item) {
            this.active = item;
        },
    },
};
</script>

<style lang="scss" scoped>
.van-dialog {
    position: fixed;
    top: unset;
    bottom: 2%;
    transform: translate3d(-50%, 0, 0);
    /deep/ {
        .van-dialog__header {
            padding: 2% 0;
        }
        .van-picker-column__item--selected {
            color: #28b86a;
            background: #f6f9fa;
            border-color: #f6f9fa;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/DialogList.vue